// Kawaii cartoon flying seagull with flapping wings.
export default function CartoonSeagull({ className = "w-28 h-24" }) {
  return (
    <svg viewBox="0 0 260 200" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true">
      <defs>
        <radialGradient id="bgBody" cx="40%" cy="35%" r="70%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="60%" stopColor="#F1F5F9" />
          <stop offset="100%" stopColor="#CBD5E1" />
        </radialGradient>
        <linearGradient id="bgWingL" x1="50%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="60%" stopColor="#E2E8F0" />
          <stop offset="100%" stopColor="#94A3B8" />
        </linearGradient>
        <radialGradient id="seagullEye" cx="35%" cy="35%" r="65%">
          <stop offset="0%" stopColor="#FDE047" />
          <stop offset="60%" stopColor="#F59E0B" />
          <stop offset="100%" stopColor="#7C2D12" />
        </radialGradient>
      </defs>
      <style>{`
        .sg-wing-l { animation: wingL 0.35s ease-in-out infinite; transform-origin: 110px 105px; }
        .sg-wing-r { animation: wingR 0.35s ease-in-out infinite; transform-origin: 150px 105px; }
        .sg-body { animation: sgBob 0.7s ease-in-out infinite; transform-origin: 130px 110px; }
        .sg-eye { animation: sgBlink 4s ease-in-out infinite; transform-origin: center; transform-box: fill-box; }
        .sg-leg { animation: sgLegs 0.7s ease-in-out infinite; transform-origin: 130px 145px; }
        @keyframes wingL { 0%, 100% { transform: rotate(-15deg); } 50% { transform: rotate(-55deg); } }
        @keyframes wingR { 0%, 100% { transform: rotate(15deg); } 50% { transform: rotate(55deg); } }
        @keyframes sgBob { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
        @keyframes sgBlink { 0%,92%,100% { transform: scaleY(1); } 94%,97% { transform: scaleY(0.1); } }
        @keyframes sgLegs { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-3px); } }
      `}</style>

      <g className="sg-body">
        {/* Wings (behind body) */}
        <g className="sg-wing-l">
          <path d="M 110 105 Q 70 75 35 95 Q 50 115 75 120 Q 95 122 110 110 Z" fill="url(#bgWingL)" stroke="#475569" strokeWidth="2" />
          {/* feather lines */}
          <path d="M 105 110 Q 80 115 55 112" stroke="#94A3B8" strokeWidth="1.5" fill="none" />
          <path d="M 100 105 Q 80 108 60 105" stroke="#94A3B8" strokeWidth="1.2" fill="none" />
          {/* Wing tip darker */}
          <path d="M 40 92 Q 55 88 70 95 L 50 105 Q 38 102 40 92 Z" fill="#64748B" opacity="0.7" />
        </g>
        <g className="sg-wing-r">
          <path d="M 150 105 Q 190 75 225 95 Q 210 115 185 120 Q 165 122 150 110 Z" fill="url(#bgWingL)" stroke="#475569" strokeWidth="2" />
          <path d="M 155 110 Q 180 115 205 112" stroke="#94A3B8" strokeWidth="1.5" fill="none" />
          <path d="M 160 105 Q 180 108 200 105" stroke="#94A3B8" strokeWidth="1.2" fill="none" />
          <path d="M 220 92 Q 205 88 190 95 L 210 105 Q 222 102 220 92 Z" fill="#64748B" opacity="0.7" />
        </g>

        {/* Body */}
        <ellipse cx="130" cy="115" rx="32" ry="38" fill="url(#bgBody)" stroke="#475569" strokeWidth="2.5" />
        {/* belly soft */}
        <ellipse cx="130" cy="135" rx="22" ry="18" fill="#F8FAFC" opacity="0.9" />

        {/* Head */}
        <circle cx="130" cy="78" r="32" fill="url(#bgBody)" stroke="#475569" strokeWidth="2.5" />
        {/* small fluff */}
        <path d="M 105 60 Q 110 50 120 55" stroke="#94A3B8" strokeWidth="1.5" fill="none" />
        <path d="M 155 60 Q 150 50 140 55" stroke="#94A3B8" strokeWidth="1.5" fill="none" />

        {/* Eyes - BIG */}
        <ellipse cx="116" cy="76" rx="12" ry="15" fill="#FFFFFF" stroke="#475569" strokeWidth="2" />
        <ellipse cx="144" cy="76" rx="12" ry="15" fill="#FFFFFF" stroke="#475569" strokeWidth="2" />
        <g className="sg-eye">
          <ellipse cx="117" cy="80" rx="8" ry="10" fill="url(#seagullEye)" />
          <ellipse cx="145" cy="80" rx="8" ry="10" fill="url(#seagullEye)" />
          <ellipse cx="117" cy="83" rx="5" ry="6" fill="#1A1A1A" />
          <ellipse cx="145" cy="83" rx="5" ry="6" fill="#1A1A1A" />
          <ellipse cx="120" cy="77" rx="2.8" ry="3.5" fill="#FFFFFF" />
          <ellipse cx="148" cy="77" rx="2.8" ry="3.5" fill="#FFFFFF" />
          <circle cx="113" cy="86" r="1.5" fill="#FFFFFF" opacity="0.9" />
          <circle cx="141" cy="86" r="1.5" fill="#FFFFFF" opacity="0.9" />
        </g>
        {/* Eyebrows happy */}
        <path d="M 103 60 Q 116 54 128 60" stroke="#475569" strokeWidth="2.2" fill="none" strokeLinecap="round" />
        <path d="M 132 60 Q 144 54 157 60" stroke="#475569" strokeWidth="2.2" fill="none" strokeLinecap="round" />

        {/* Beak - orange */}
        <path d="M 128 96 Q 130 110 155 102 Q 145 110 130 104 Q 122 104 128 96 Z" fill="#F97316" stroke="#7C2D12" strokeWidth="1.8" />
        <path d="M 138 99 L 152 102 L 148 105 Z" fill="#FB923C" />

        {/* Cheeks pink */}
        <ellipse cx="105" cy="92" rx="6" ry="3" fill="#F472B6" opacity="0.4" />
        <ellipse cx="156" cy="92" rx="6" ry="3" fill="#F472B6" opacity="0.4" />

        {/* Legs */}
        <g className="sg-leg">
          <line x1="125" y1="148" x2="125" y2="170" stroke="#F97316" strokeWidth="3" strokeLinecap="round" />
          <line x1="135" y1="148" x2="135" y2="170" stroke="#F97316" strokeWidth="3" strokeLinecap="round" />
          {/* feet */}
          <path d="M 119 170 L 131 170 L 125 175 Z" fill="#F97316" />
          <path d="M 129 170 L 141 170 L 135 175 Z" fill="#F97316" />
        </g>
      </g>
    </svg>
  );
}
